module.exports = __webpack_public_path__ + "static/img/japutra_12.d40d543.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/japutra_12.jpg
// module id = yaTd
// module chunks = 0